import { render, staticRenderFns } from "./BoomLiftPermit.vue?vue&type=template&id=7c2b22cb"
import script from "./BoomLiftPermit.vue?vue&type=script&lang=js"
export * from "./BoomLiftPermit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports